import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, FormControl, InputLabel, Select, MenuItem, useTheme
} from '@mui/material';

const defaultValues = {
  name: '',
  phone: '',
  email: '',
  source: 'Whatsapp',
  tags: ''
};

function CreateContactDialog({ open, onClose, onSave, initialValues }) {
  const theme = useTheme();
  const [contact, setContact] = useState(defaultValues);

  useEffect(() => {
    setContact(initialValues ? { ...defaultValues, ...initialValues } : defaultValues);
  }, [initialValues, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContact((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    onSave && onSave(contact);
    onClose && onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Create New Contact</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Contact Name"
              name="name"
              value={contact.name}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Phone Number"
              name="phone"
              value={contact.phone}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={contact.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Source</InputLabel>
              <Select
                name="source"
                value={contact.source}
                onChange={handleChange}
                label="Source"
              >
                <MenuItem value="Whatsapp">Whatsapp</MenuItem>
                <MenuItem value="Website">Website</MenuItem>
                <MenuItem value="Phone">Phone</MenuItem>
                <MenuItem value="Email">Email</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Tags (comma separated)"
              name="tags"
              value={contact.tags}
              onChange={handleChange}
              placeholder="e.g., customer, vip, prospect"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose}
          sx={{
            color: theme.palette.primary.main,
            fontWeight: 600,
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.04)'
            }
          }}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleSave} 
          variant="contained" 
          sx={{ 
            bgcolor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontWeight: 600,
            '&:hover': {
              bgcolor: theme.palette.primary.dark,
              boxShadow: 2
            }
          }}
        >
          Create Contact
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateContactDialog; 